import { render, staticRenderFns } from "./DominioStatus.vue?vue&type=template&id=6aa658c4"
import script from "./DominioStatus.vue?vue&type=script&lang=js"
export * from "./DominioStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports